const localOrderStorageKey = 'localOrderStorage';

export const readLocalOrderStorage = (): string[] => {
  const localOrderStorage = localStorage.getItem(localOrderStorageKey);

  return localOrderStorage ? JSON.parse(localOrderStorage) : [];
};

export const writeLocalOrderStorage = (code: string) => {
  const localOrderStorage = readLocalOrderStorage();
  const updatedOrders = [...new Set([...localOrderStorage, code])];

  localStorage.setItem(localOrderStorageKey, JSON.stringify(updatedOrders));
}
